import { Icon } from '@chakra-ui/react';

export const SelfScoreBold = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M7 16.0054C7 14.3485 8.34315 13.0054 10 13.0054H14C15.6569 13.0054 17 14.3485 17 16.0054V18.9407C17 18.9737 16.9732 19.0005 16.9402 19.0005H7.05981C7.02678 19.0005 7 18.9737 7 18.9407V16.0054Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M14.2859 7.42599C14.2859 8.76553 13.1991 9.85247 11.8573 9.85247C10.5154 9.85247 9.42871 8.76553 9.42871 7.42599C9.42871 6.08646 10.5154 4.99951 11.8573 4.99951C13.1991 4.99951 14.2859 6.08646 14.2859 7.42599Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
  </Icon>
);
